import axios from 'axios';
import { AxiosError } from 'axios';
import keycloak from '@app/Keycloack';
import { ApiError } from './ApiError';

export interface ApiErrorData {
  message: string;
}

export const httpApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

httpApi.interceptors.request.use((config) => {
  config.headers = { ...config.headers };
  return config;
});

httpApi.interceptors.response.use(undefined, (error: AxiosError) => {
  if (error.response?.status === 401 && error.config) {
    window.history.pushState({}, '/');
    keycloak.logout();
  }
  const message =
    (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
  throw new ApiError<ApiErrorData>(message);
});

export const setSession = (access_token: string): void => {
  access_token
    ? (httpApi.defaults.headers.common.Authorization = `Bearer ${access_token}`)
    : delete httpApi.defaults.headers.common.Authorization;
};
